/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import React from "react";
import { Breadcrumbs, Link, Box, Button } from "@mui/material";
import { Stack } from "@mui/system";
import _ from "lodash";
import useAuth from "../hooks/use-auth";

const CustomToolBar = ({ title, paths }) => {
  // CSS
  const titleArea = css({
    width: "min(620px, 100vw - 40px)",
    h2: { letterSpacing: "1.5px", paddingInline: "10px", flexShrink: 0 },
    hr: { borderTop: "1px solid #e6e6e6", width: "100%" },
  });

  const breadArea = css({
    position: "absolute",
    right: 0,
    background: "white",
    padding: "10px 20px",
    "@media(max-width: 768px)": {
      position: "unset",
    },
  });

  const signOutBtn = css({
    minWidth: "auto",
    color: "#00000099",
    fontWeight: 400,
  });

  const { signOut } = useAuth();

  return (
    <>
      <Stack
        direction="row"
        justifyContent="center"
        alignItems="center"
        sx={{ position: "relative", flexWrap: "wrap", marginBottom: "10px"}}
      >
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          css={titleArea}
        >
          <hr />
          <h2>{title}</h2>
          <hr />
        </Stack>
        <Box css={breadArea}>
          <Breadcrumbs aria-label="breadcrumb">
            {_.map(paths, (path, index) =>
              path.isSignOut ? (
                <Button key={index} css={signOutBtn} onClick={signOut}>
                  登出
                </Button>
              ) : (
                <Link
                  key={index}
                  underline="hover"
                  color="inherit"
                  href={path.link}
                >
                  {path.title}
                </Link>
              )
            )}
          </Breadcrumbs>
        </Box>
      </Stack>
    </>
  );
};

export default CustomToolBar;
